import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { TextItemValidation } from './types-store';

export const clearValidationForKey = (
  validation: TextItemValidation,
  key: 'textSet' | 'textCollection'
): TextItemValidation =>
  (validation?.[key]?.messages?.length ?? 0) > 0
    ? Object.keys(validation).reduce((currentValidation, currentKey) =>
      key === currentKey
        ? currentValidation
        : {
          ...currentValidation,
          [currentKey]: validation[currentKey]
        }, {} as TextItemValidation)
    : validation;

export const clearValidationForSingleParameter = (
  validation: TextItemValidation,
  parameter: string,
  id: number
): TextItemValidation =>
  validation?.language?.messages
    ? {
      ...validation,
      language: {
        ...validation.language,
        messages: validation.language.messages.filter(
          m => !m || !m.parameters || !isDefinedIncludingZero(m.parameters[parameter]) || m.parameters[parameter] !== id)
      }
    }
    : validation;

export const clearValidationForAllParameter = (
  validation: TextItemValidation,
  parameter: string
): TextItemValidation =>
  validation?.language?.messages
    ? {
      ...validation,
      language: {
        ...validation.language,
        messages: validation.language.messages.filter(
          m => !m || !m.parameters || !isDefinedIncludingZero(m.parameters[parameter]))
      }
    }
    : validation;
